export interface PageSeoConfig {
  title: string;
  description: string;
  path: string;
  image: string;
  category: string;
  badge: string;
}

export const DOMAIN = 'https://azuraos.app';

export const ROUTE_SEO_MAP: Record<string, PageSeoConfig> = {
  '/': {
    title: 'AzuraOS — Global Solvency Radar & Cohort Governance OS',
    description: 'Forward solvency radar and financial governance OS for startup cohorts, accelerators, incubators, venture studios, and solo founders with Multi-Provider BYOK.',
    path: '/',
    image: `${DOMAIN}/og-image.png`,
    category: 'COHORT GOVERNANCE & SOLVENCY RADAR',
    badge: 'ACCELERATOR READY'
  },
  '/cohorts': {
    title: 'Your Cohort Teaches Founders to Build. What Helps Them Run the Business? | AzuraOS Cohort Pilot',
    description: 'Extend practical business-operating support beyond mentorship. Turnkey structured cohort solvency pilot for accelerators, incubators, and venture studios with Multi-Provider BYOK.',
    path: '/cohorts',
    image: `${DOMAIN}/og-image.png`,
    category: 'INSTITUTIONAL COHORTS',
    badge: 'STRUCTURED COHORT PILOT'
  },
  '/accelerators': {
    title: 'Accelerator Cohort Solvency Pilot & Governance OS | AzuraOS',
    description: 'Extend practical business-operating support beyond mentorship. Turnkey structured cohort solvency pilot for accelerators, incubators, and venture studios with Multi-Provider BYOK.',
    path: '/accelerators',
    image: `${DOMAIN}/og-image.png`,
    category: 'ACCELERATOR INFRASTRUCTURE',
    badge: 'STRUCTURED COHORT PILOT'
  },
  '/incubators': {
    title: 'Incubator & Studio Solvency Portal | AzuraOS',
    description: 'Prevent post-demo day tax insolvency across incubatees with deterministic holding buffers and sovereign multi-provider AI.',
    path: '/incubators',
    image: `${DOMAIN}/og-image.png`,
    category: 'INCUBATOR SUBLICENSE',
    badge: 'ESD & GRANT READY'
  },
  '/enterprise': {
    title: 'Enterprise Supplier Solvency Radar | AzuraOS',
    description: 'Enterprise ESD and SME supplier development solvency tracking with zero-custody governance and private banking isolation.',
    path: '/enterprise',
    image: `${DOMAIN}/og-image.png`,
    category: 'ENTERPRISE & BANKS',
    badge: 'SUPPLIER GOVERNANCE'
  },
  '/dashboard': {
    title: 'Founder Dashboard & Margin Radar | AzuraOS',
    description: 'Track income streams, calculate live net margin percentage, and simulate business decisions before committing capital.',
    path: '/dashboard',
    image: `${DOMAIN}/og-image-dashboard.png`,
    category: 'EXECUTIVE DASHBOARD',
    badge: 'REAL-TIME MARGINS'
  },
  '/app': {
    title: 'Founder Dashboard & Margin Radar | AzuraOS',
    description: 'Track income streams, calculate live net margin percentage, and simulate business decisions before committing capital.',
    path: '/dashboard',
    image: `${DOMAIN}/og-image-dashboard.png`,
    category: 'EXECUTIVE DASHBOARD',
    badge: 'REAL-TIME MARGINS'
  },
  '/billing': {
    title: 'Subscription & Plans | AzuraOS Sovereign Founder Pro',
    description: 'Manage your active 7-day free trial, unlock unlimited bookings & invoices, J-Lens cash flow forecasting, and 24/7 AI Co-Founder intelligence.',
    path: '/billing',
    image: `${DOMAIN}/og-image-billing.png`,
    category: 'BILLING & ACCESS',
    badge: '7-DAY FREE TRIAL'
  },
  '/invoices': {
    title: 'Invoices & Receivables | AzuraOS',
    description: 'Generate professional PDF invoices, track paid vs unpaid receivables, and streamline client payments with automated tax breakdown.',
    path: '/invoices',
    image: `${DOMAIN}/og-image-invoices.png`,
    category: 'INVOICING ENGINE',
    badge: 'INSTANT PDF EXPORT'
  },
  '/bookings': {
    title: 'Bookings & Client Retainers | AzuraOS',
    description: 'Log client service bookings, manage project retainers, and connect appointments directly to Google Calendar.',
    path: '/bookings',
    image: `${DOMAIN}/og-image-bookings.png`,
    category: 'REVENUE & SCHEDULING',
    badge: 'CALENDAR SYNC'
  },
  '/expenses': {
    title: 'Operating Expenses & Tax Deductions | AzuraOS',
    description: 'Categorize business outflows, harvest allowable tax deductions, and safeguard net profit margins against overhead creep.',
    path: '/expenses',
    image: `${DOMAIN}/og-image-expenses.png`,
    category: 'COST MANAGEMENT',
    badge: 'TAX DEDUCTIBLE'
  },
  '/j-lens': {
    title: 'J-Lens Strategic Cash Flow Vault | AzuraOS',
    description: 'Deep revenue and expense analysis, profit margin forecasting, and strategic cognitive insights for solo founders.',
    path: '/j-lens',
    image: `${DOMAIN}/og-image-jlens.png`,
    category: 'STRATEGIC ANALYTICS',
    badge: 'FOUNDER PRO'
  },
  '/ai-assistant': {
    title: 'AI Co-Founder & Fractional CFO | AzuraOS',
    description: 'Autonomous strategic intelligence, margin optimization audits, proposal reviews, and legal scope defense with 100% BYOK privacy.',
    path: '/ai-assistant',
    image: `${DOMAIN}/og-image-ai.png`,
    category: 'STRATEGIC AI COPILOT',
    badge: 'ZERO AI TRAINING'
  },
  '/calendar': {
    title: 'Calendar & Bookings | AzuraOS — Client Scheduling Engine',
    description: 'Manage client bookings, recurring retainers, and Google Calendar appointments seamlessly.',
    path: '/calendar',
    image: `${DOMAIN}/og-image-bookings.png`,
    category: 'CALENDAR SCHEDULING',
    badge: 'GOOGLE CALENDAR'
  },
  '/book': {
    title: 'Public Client Booking Portal | AzuraOS',
    description: 'Schedule a consultation or booking directly with instant confirmation and seamless payment options.',
    path: '/book',
    image: `${DOMAIN}/og-image-book.png`,
    category: 'CLIENT PORTAL',
    badge: 'INSTANT CONFIRMATION'
  },
  '/settings': {
    title: 'Business HQ & Tax Architecture | AzuraOS',
    description: 'Structure multiple business streams, configure multi-currency VAT/Tax rules, and track founder profitability in an AES-256 cloud vault.',
    path: '/settings',
    image: `${DOMAIN}/og-image-settings.png`,
    category: 'BUSINESS ARCHITECTURE',
    badge: 'AES-256 ENCRYPTED'
  },
  '/admin': {
    title: 'Super-Admin Console & Control Hub | AzuraOS',
    description: 'Master administrative access, whitelist enforcement, institutional RFP specifications, and emergency platform switches.',
    path: '/admin',
    image: `${DOMAIN}/og-image.png`,
    category: 'ADMINISTRATION',
    badge: 'SUPER-ADMIN ONLY'
  },
  '/hq': {
    title: 'Business HQ & Tax Architecture | AzuraOS',
    description: 'Structure multiple business streams, configure multi-currency VAT/Tax rules, and track founder profitability in an AES-256 cloud vault.',
    path: '/settings',
    image: `${DOMAIN}/og-image-settings.png`,
    category: 'BUSINESS ARCHITECTURE',
    badge: 'AES-256 ENCRYPTED'
  },
  '/focus': {
    title: 'Focus Roadmap & Revenue Milestones | AzuraOS',
    description: 'Set financial goals, track revenue milestones, and prioritize growth initiatives with real-time feedback and high-leverage sprints.',
    path: '/focus',
    image: `${DOMAIN}/og-image-focus.png`,
    category: 'OPERATIONAL FOCUS',
    badge: 'REVENUE VELOCITY'
  },
  '/welcome': {
    title: 'Welcome Aboard & BYOK Quickstart | AzuraOS',
    description: 'Get started with AzuraOS in under 60 seconds, connect your free Google AI Studio key, and experience sovereign founder control.',
    path: '/welcome',
    image: `${DOMAIN}/og-image-welcome.png`,
    category: 'FOUNDER ONBOARDING',
    badge: 'QUICKSTART HUB'
  },
  '/what-is-azuraos': {
    title: 'What is AzuraOS? Global Solvency & Cohort Financial Platform',
    description: 'Explore how AzuraOS replaces 5+ disconnected tools with a real-time forward solvency radar for invoices, agreements, and margin defense.',
    path: '/what-is-azuraos',
    image: `${DOMAIN}/og-image.png`,
    category: 'EXPLAINER & ARCHITECTURE',
    badge: 'GLOBAL ARCHITECTURE'
  },
  '/whatisazuraos': {
    title: 'What is AzuraOS? Global Solvency & Cohort Financial Platform',
    description: 'Explore how AzuraOS replaces 5+ disconnected tools with a real-time forward solvency radar for invoices, agreements, and margin defense.',
    path: '/what-is-azuraos',
    image: `${DOMAIN}/og-image.png`,
    category: 'EXPLAINER & ARCHITECTURE',
    badge: 'GLOBAL ARCHITECTURE'
  },
  '/terms': {
    title: 'Terms of Service | AzuraOS Governance & Legal',
    description: 'Review terms of service, user rights, and operational agreements for AzuraOS.',
    path: '/terms',
    image: `${DOMAIN}/og-image.png`,
    category: 'LEGAL & GOVERNANCE',
    badge: 'TRANSPARENCY'
  },
  '/privacy': {
    title: 'Privacy Policy | AzuraOS Sovereign Data Rights',
    description: 'Learn how AzuraOS protects your financial data with local-first encryption, zero AI model training, and sovereign cloud vault architecture.',
    path: '/privacy',
    image: `${DOMAIN}/og-image.png`,
    category: 'PRIVACY & SECURITY',
    badge: 'ZERO AI TRAINING'
  },
  '/faq': {
    title: 'Frequently Asked Questions | AzuraOS',
    description: 'Common questions regarding AzuraOS, data security, cloud vault sync, Dodo Payments, and profitability features.',
    path: '/faq',
    image: `${DOMAIN}/og-image.png`,
    category: 'HELP & FAQ',
    badge: 'KNOWLEDGE BASE'
  },
  '/refund': {
    title: 'Refund Policy | AzuraOS',
    description: 'Transparent refund and trial policy for AzuraOS subscriptions and plans.',
    path: '/refund',
    image: `${DOMAIN}/og-image.png`,
    category: 'BILLING & REFUNDS',
    badge: '3-DAY TRIAL'
  },
  '/security': {
    title: 'Security & Compliance | AzuraOS Sovereign Safeguards',
    description: 'Discover how AzuraOS safeguards your business records with row-level security, encrypted cloud vaults, and BYOK execution.',
    path: '/security',
    image: `${DOMAIN}/og-image.png`,
    category: 'ENTERPRISE SECURITY',
    badge: 'ROW-LEVEL SECURITY'
  }
};

export function getSeoConfigForPath(pathname: string): PageSeoConfig {
  const normalized = pathname.split('?')[0].split('#')[0] || '/';
  
  if (ROUTE_SEO_MAP[normalized]) {
    return ROUTE_SEO_MAP[normalized];
  }

  // Prefix matching
  for (const [route, config] of Object.entries(ROUTE_SEO_MAP)) {
    if (route !== '/' && normalized.startsWith(route)) {
      return config;
    }
  }

  return ROUTE_SEO_MAP['/'];
}
